export const GreenGlass10 = () => {
  return (
    <radialGradient
      id="svg-gradient-green-glass-10"
      cx="50%"
      cy="100%"
      r="50%"
      fx="50%"
      fy="100%"
    >
      <stop offset="0%" stopColor="#26EAAC" />
      <stop offset="100%" stopColor="#1A897C" />
    </radialGradient>
  )
}
